if (!Object.prototype.hasOwnProperty.call(RegExp, 'escape')) {
  RegExp.escape = function (string) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
    // https://github.com/benjamingr/RegExp.escape/issues/37
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
  }
}



// WEBPACK FOOTER //
// ./src/utils/polyfill.js